import axiosInstance from '../axiosInstance';
import { IResponse } from '../types';
import { ICheckIfTicketHasChannelResponse, ISmsChannelHistory } from '../smsConversations/types';
import { ITeamsChatMessagePayload, ITeamsCreateChatPayload } from './types';

export const checkIfTeamsChatExists = (
  ticketId: number,
  psaId: number,
  contactId: number,
): IResponse<ICheckIfTicketHasChannelResponse> =>
  axiosInstance.request({
    method: 'GET',
    url: `/TeamsMessagingBoard/checkTicketChannels?ticketId=${ticketId}&crmId=${psaId}&contactId=${contactId}`,
  });

export const teamsCreateChat = (payload: ITeamsCreateChatPayload): IResponse<number> =>
  axiosInstance.request({
    method: 'POST',
    url: '/TeamsMessagingBoard/createChannel',
    data: payload,
  });

export const sendTeamsChatMessage = (
  chatId: number,
  payload: ITeamsChatMessagePayload,
): IResponse<ISmsChannelHistory> =>
  axiosInstance.request({
    method: 'POST',
    url: `/TeamsMessagingBoard/channels/${chatId}/send`,
    data: payload,
  });

export const getTeamsChannelHistory = (chatId: number): IResponse<ISmsChannelHistory[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/TeamsMessagingBoard/channels/${chatId}/channelHistory`,
  });
